import type {
    StoreDetailsInviteUserFormValues,
    StoreDetailsInviteUserLoginMethod,
    StoreDetailsInviteUserRole,
} from '../../../../types/features/storeDetails/users';
import type { InviteStoreUserPayload } from '../../../../types/services/auth';

export const STORE_DETAILS_INVITE_USER_ROLES: StoreDetailsInviteUserRole[] = ['operator', 'manager'];

export const STORE_DETAILS_INVITE_LOGIN_METHODS: StoreDetailsInviteUserLoginMethod[] = ['phone', 'email', 'pin'];

export const getDigitsOnly = (value: string | null | undefined): string => String(value || '').replace(/\D/g, '');

export const formatStoreDetailsInviteUserRole = (role: StoreDetailsInviteUserRole): string =>
    role.charAt(0).toUpperCase() + role.slice(1);

export const isStoreDetailsInvitePinLoginAllowed = (role: StoreDetailsInviteUserRole): boolean => role === 'operator';

export const shouldShowStoreDetailsRecoPermission = (role: StoreDetailsInviteUserRole): boolean =>
    role === 'manager';

export const buildStoreDetailsInviteUserPayload = (
    values: StoreDetailsInviteUserFormValues,
): InviteStoreUserPayload => {
    const trimmedName = values.name.trim();
    const trimmedEmail = values.email.trim();
    const phoneDigits = getDigitsOnly(values.phone_number);
    const pinDigits = getDigitsOnly(values.cashier_mode_pin);
    const payload: InviteStoreUserPayload = {
        name: trimmedName,
        role: values.role,
    };

    if (shouldShowStoreDetailsRecoPermission(values.role)) {
        payload.can_approve_reconciliation = values.can_approve_reconciliation;
    }

    if (values.loginMethod === 'pin') {
        payload.cashier_mode_pin = pinDigits;
        return payload;
    }

    if (values.loginMethod === 'email') {
        payload.login_field = 'email';
        payload.email = trimmedEmail;
        payload.phone_number = phoneDigits || null;
        return payload;
    }

    payload.login_field = 'phone';
    payload.phone_number = phoneDigits;
    if (trimmedEmail) {
        payload.email = trimmedEmail;
    }

    return payload;
};
